import Auth from '../modules/Authentication'
import { handleErrors, handleResponse } from '../modules/Utils'
import { apiUrl } from '../variables/index'

const headers = {}

export default class Leaves {
  auth = new Auth()
  list = ({ owner, status }) => {
    const select = [
      '_key',
      '_id',
      '_rev',
      'reason',
      'type',
      'owner',
      'date',
      'status',
      'half',
      'leave',
      'total',
    ].toString()
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(
      `${apiUrl}leaves?select=${select}` +
        (owner ? `&owner=${owner || ''}` : '') +
        (status ? `&status=${status || ''}` : ''),
      {
        headers: headers,
        method: 'GET',
      }
    )
      .then(handleErrors)
      .then(handleResponse)
  }
  holidays = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}leaves/holidays`, {
      headers: headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  read = (key, owner) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}leaves/${key}` + (owner ? `?owner=${owner || ''}` : ''), {
      headers: headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  create = (data, owner) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}leaves/` + (owner ? `?owner=${owner || ''}` : ''), {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  getTotal = (data) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}leaves/total`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  remove = (data, owner) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}leaves/` + (owner ? `?owner=${owner || ''}` : ''), {
      headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
  operation = (key, data) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}leaves/${key}`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  update = (data, owner) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}leaves/` + (owner ? `?owner=${owner || ''}` : ''), {
      headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
  entitlements = (key) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}/entitlements/${key}/current`, {
      headers: headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  cancel = (data, owner) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}leaves/cancel` + (owner ? `?owner=${owner || ''}` : ''), {
      headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
}
